import { bucketType, bucketTypeOption } from "../features/createBucket/CreateBucketTypes";
import { manageUpdateAccessObj } from "../features/manageUpdateAccess/manageUpdateAccessTypes";
import { ChannelkartNetworkGet, ChannelkartNetworkPut, sizeParam } from "./networkService";

export async function fetchAllBuckets(){
    const url = '/metadata/clientconfig';
    try{
        const response = await ChannelkartNetworkGet(url);
        const bucketConfig = response.data.features.find((Obj: { domainType: string }) => {
            return Obj.domainType === 'bucket_configuration'
        })
        return bucketConfig?.domainValues;
        
    }catch(err){
        console.log(err);
    }
    
}

export async function updateBucketConfig(requestBody:any,configName: string,verifiedUser?: manageUpdateAccessObj){
    try {
        const url = verifiedUser? `/metadata/clientconfig?name=${configName}&verifiedBy=${verifiedUser.phoneNumber}` : `/metadata/clientconfig?name=${configName}`
        const response = await ChannelkartNetworkPut(url,requestBody);
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
export async function fetchBucketTypeAllOptions(urlParam: bucketType){
    try{
        const response = await ChannelkartNetworkGet(`/v1/distinctFieldData/productDetails/${urlParam}?size=${sizeParam}`);
        const finalOptions = response.data.filter((option: bucketTypeOption) => typeof(option[urlParam]) === "string").map((option: bucketTypeOption) => {
            return option[urlParam];
        })
        return finalOptions;
    }catch(err){
        console.log(err);
        return [];
    }
}
export async function getGridOptionMapping(primaryType:string,secondaryType:string,primaryOptions:string[]){
    try{
        const primaryProp: bucketType = getUrlParam(primaryType);
        const secondaryProp: bucketType = getUrlParam(secondaryType);
        const response = await ChannelkartNetworkGet(`/products?size=${sizeParam}`);
        const allProducts = response.data.features;
        const tempGridOptionMapping = primaryOptions.map((option: string) => {
            return {
                name: option,
                secondaryOptions: allProducts.filter((product: any) => {
                    return product[primaryProp] === option && product[secondaryProp];
                }).map((product: any) => product[secondaryProp])
            }
        });
        const gridOptionMapping = tempGridOptionMapping.map((product) => {
            return {
                name: product.name,
                secondaryOptions: Array.from(new Set(product.secondaryOptions)) as string[]
            }
        })
        return gridOptionMapping;
    }catch(err){
        console.log(err);
        return [];
    }
}
// export function getUrlParam(bucketType: string){
//     return bucketType==="Pack Size"? "pieceSize" : (bucketType==="Smart Buy"? "smartBuy" : bucketType.toLowerCase()) as bucketType;
// }
  export function getUrlParam(bucketType: string) {
    return bucketType === "Pack Size"
      ? "pieceSize"
      : bucketType === "Smart Buy"
      ? "smartBuy"
      : bucketType === "Sub Category"
      ? "subCategory"
      : bucketType === "Sub Brand"
      ? "subBrand"
      : bucketType === "Piece Size Description"
      ? "pieceSizeDesc"
      : bucketType === "Brand Code"
      ? "brandCode"
      : (bucketType.toLowerCase() as bucketType);
  }
export async function fetchBucketSubTypeOptions(primaryType: string, secondaryType: string, primaryItem: string){
    try{
        const  urlParam1: bucketType = getUrlParam(primaryType);
        const  urlParam2: bucketType = getUrlParam(secondaryType);


        const response = await ChannelkartNetworkGet(`/v1/distinctFieldData/productDetails/${urlParam2}?filter=${urlParam1}:${primaryItem}&size=${sizeParam}`);
        const finalOptions = response.data.filter((option: bucketTypeOption) => typeof(option[urlParam2]) === "string").map((option: bucketTypeOption) => {
            return option[urlParam2];
        })
        return finalOptions;
    }catch(err){
        console.log(err);
        return [];
    }
}